module.exports = __webpack_public_path__ + "img/icon_recycle_bin.26faa2fb.png";